import api from './api';

const ENDPOINT = 'clients';

const ClientService = {
  getSelf: () => api.get(`${ENDPOINT}/self`),
  update: (id, data) => api.put(`${ENDPOINT}/${id}`, data),
  getIncomplete: (cpf) =>
    api.get(`${ENDPOINT}/incomplete`, { params: { cpf } }),
  updatePassword: (data) => api.put(`${ENDPOINT}/update-password`, data),
  requestCardDuplicate: (reason) =>
    api.post(`${ENDPOINT}/request-card-duplicate`, { reason }),
  sendContact: (data) => api.post(`${ENDPOINT}/send-contact`, data),
  activateCard: (number) => api.post(`${ENDPOINT}/activate-card`, { number }),
  verifyCardStatus: () => api.get(`${ENDPOINT}/verify-card-status`),
  resetSolicitation: (cpf) =>
    api.post(`${ENDPOINT}/reset-solicitation`, { cpf }),
  verifySolicitation: (uuid) =>
    api.get(`${ENDPOINT}/verify-solicitation`, {
      params: {
        uuid,
      },
    }),
  resetPassword: (data) => api.put(`${ENDPOINT}/reset-password`, data),
};

export default ClientService;
